import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Story from "../pages/story/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/story/:id",
    element: <Story />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;